export enum PetCareType {
  DEWORMING = "deworming",
  FLEA_CONTROL = "flea_control",
}

export enum FrequencyType {
  MONTHLY = "monthly",
  QUATERLY = "quaterly",
  BI_WEEKLY = "bi-weekly",
  THREE_MONTHS = "three-months",
  OTHER = "other",
}

export interface PetCare {
  id: string;
  memberId: string;
  type: PetCareType;
  frequencyType: FrequencyType;
  frequency?: number;
  nextDueDate: Date;
  reminderDays?: number;
  reminderTime?: string;
  enabled?: boolean;
}

export interface PetCareRequest {
  type: PetCareType;
  frequencyType: FrequencyType;
  frequency?: number;
  nextDueDate: Date;
  reminderDays?: number;
  reminderTime?: string;
  enabled?: boolean;
  timezone?: string;
  tier?: "ROUTINE" | "CRITICAL";
}

export interface MarkDoneRequest {
  memberId: string;
  type: PetCareType;
  takenOn: Date;
  medicineName: string;
  notes?: string;
}

export interface PetCareHistory {
  reminderDays?: number;
  dueDate: Date;
}
